import './App.css';
import AuthPage from './pages/AuthPage';
import { Routes, Route, useNavigate } from "react-router-dom";
import ProtectedRoute from './components/protected/ProtectedRoute';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import Home from './components/Home';
import theme from './config/theme';
import LeadsPage from './pages/Leads';
import Settings from './pages/Settings';
import FollowUps from './pages/FollowUps';
import Analytics from './pages/Analytics';
import HelpCenter from './pages/HelpCenter';
import LeadsGenerator from './pages/LeadsGenerator';
import Subscription from './pages/Subscription';
import Dashboard from './pages/Dashboard';
import AlertsAndNotifications from './pages/AlertsAndNotifications';
import CampaignBuilder from './pages/Campaign/CampaignBuilder';
import BusinessInfo from './pages/BusinessInfo';
import Campaigns from './pages/Campaigns';
import NotFound from './pages/NotFound';
import { useEffect } from 'react';
import { setNavigate } from "./navigation";

/* Application with Login - Authentication - API - Protected Routes */
export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    // Store the navigate function globally so apiService can use it
    setNavigate(navigate);
  }, [navigate]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline/> {/* It will reset default settings like margin, pading and update theme globally*/}


            <Routes>

              {/* Protected routes */}
              <Route element={<ProtectedRoute/>}>
                  {/* place here  routes which need to be protected*/}
                  <Route path="/home/*" element={<Home/>} />
              </Route>

              {/* UnProtected routes */}
              <Route path="/" element={ <AuthPage/>}/>
              <Route path="*" element={<NotFound />} />
              
              {/* Development routes - only available in development mode */}
              {process.env.NODE_ENV === 'development' && (
                <>
                  <Route path="/lead" element={<LeadsPage/>} />
                  <Route path="/set" element={<Settings/>} />
                  <Route path="/followup" element={<FollowUps/>} />
                  <Route path="/analytics" element={<Analytics/>} />
                  <Route path="/leadgen" element={<LeadsGenerator/>} />
                  <Route path="/sub" element={<Subscription/>} />
                  <Route path="/dash" element={<Dashboard/>} />
                  <Route path="/help" element={<HelpCenter/>} />
                  <Route path="/alert" element={<AlertsAndNotifications/>} />
                  <Route path="/campb" element={<CampaignBuilder/>} />
                  <Route path="/camp" element={<Campaigns/>} />
                  <Route path="/biz" element={<BusinessInfo/>} />
                </>
              )}
            </Routes>


      </ThemeProvider>
    </>
  );
}



